export enum UseCases {
    Starter = 'starter',
    Databases = 'databases',
    Ai = 'ai',
    Messaging = 'messaging',
    Utilities = 'utilities',
    Devtools = 'dev-tools',
    Auth = 'auth',
    Portfolio = 'portfolio',
    Events = 'events',
    Ecommerce = 'ecommerce',
    Documentation = 'documentation',
    Blog = 'blog',
    Forms = 'forms',
    Dashboard = 'dashboard',
}